import './index.css';

export default {
  name: 'Atyping',
  props: {
    id: { type: String, default: () => (`a-typing-${Math.random().toString().substring(2)}`) },
    speed: { type: Number | String, default: () => 10 }, // 输出速度(值越小越快)
    text: { type: String, default: () => null },
    value: { type: String, default: () => null },
    values: { type: String, default: () => null },
    content: { type: String, default: () => null },
    context: { type: String, default: () => null },
  },
  data() {
    return ({
      timeout: null,
    });
  },
  watch: {
    text() { this.create() },
    value() { this.create() },
    values() { this.create() },
    content() { this.create() },
    context() { this.create() },
  },
  mounted() {
    this.create();
  },
  destroyed() {
    this.revoke();
  },
  methods: {
    create() {
      this.revoke();
      this.$nextTick(() => {
        const text = this.context || this.content || this.values || this.value || this.text;
        const context = text.replace(/<[^>]*>/g, '');
        for (let a = 0; a <= context.length; a++) {
          this.cancel();
          this.$nextTick(() => {
            this.timeout = setTimeout(() => {
              this.$el.innerHTML += context.charAt(a);
            }, (this.speed * a));
          });
        }
      });
    },
    cancel() {
      if (this.timeout) {
        clearTimeout(this.timeout);
        this.timeout = null;
      }
    },
    revoke() {
      this.cancel();
      this.$nextTick(() => this.$el.innerHTML = '');
    },
  },
  render() {
    const { width, height, padding, margin } = this.$attrs;
    return (<div class="a-typing" id={this.id} style={{ width, height, padding, margin }} />);
  }
}